import { DomainWithFilespaces, FilespaceExtended } from 'fs-api-client';

export function sortFilespaces(domains: DomainWithFilespaces []) {
    domains.forEach((domain) => {
        domain.filespaces
            .sort((a, b) => {
                if (a.isDeleted && !b.isDeleted) { return 1; }
                if (!a.isDeleted && b.isDeleted) { return -1; }
                if (a.isDeleted && b.isDeleted) { return b.deletionDate! - a.deletionDate!; }

                return `${a.name}.${a.domain}`.localeCompare(`${b.name}.${b.domain}`);
            });
    });
}

type FilespaceItemStyle = {
    opacity: number;
};

export function getFilespaceItemStyle(filespace: FilespaceExtended): FilespaceItemStyle {
    return { opacity: filespace.isDeleted ? 0.4 : 1 };
}



// WEBPACK FOOTER //
// ./src/backoffice/utils/utilFunctions.ts